import React from 'react';
import styles from '../../styles/AplicacionPagosStyles/AplicacionPagos.module.css';

function StudentTable({ students, onSelectStudent, loading }) {
  if (loading) {
    return (
      <div className={styles.tableContainer}>
        <p style={{ textAlign: 'center', padding: '20px' }}>Cargando estudiantes...</p>
      </div>
    );
  }

  if (!students || students.length === 0) {
    return (
      <div className={styles.tableContainer}>
        <p style={{ textAlign: 'center', padding: '20px' }}>
          No se encontraron estudiantes con adeudos pendientes
        </p>
      </div>
    );
  }

  return (
    <div className={styles.tableContainer}>
      <div className={styles.table}>
        <div className={styles.tableHeader}>
          <div className={styles.headerCell}>Nombre</div>
          <div className={styles.headerCell}>Matrícula</div>
          <div className={styles.headerCell}>Campus</div>
          <div className={styles.headerCell}>Programa</div>
          <div className={styles.headerCell}>Ciclo Escolar</div>
        </div>
        
        <div className={styles.tableBody}>
          {students.map((student) => (
            <div 
              key={student.id} 
              className={styles.tableRow}
              onClick={() => onSelectStudent(student)}
            >
              <div className={styles.tableCell}>{student.nombre}</div>
              <div className={styles.tableCell}>{student.matricula}</div>
              <div className={styles.tableCell}>{student.campus}</div>
              <div className={styles.tableCell}>{student.programa}</div>
              <div className={styles.tableCell}>{student.ciclo_escolar}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default StudentTable;
